import { useState } from "react";

export const useAssessmentModal = () => {
	const [selectedAssessment, setSelectedAssessment] = useState(null);
	const [isGradesModalOpen, setIsGradesModalOpen] = useState(false);

	const openGradesModal = (assessment) => {
		setSelectedAssessment(assessment);
		setIsGradesModalOpen(true);
	};

	const closeGradesModal = () => {
		setSelectedAssessment(null);
		setIsGradesModalOpen(false);
	};

	return {
		selectedAssessment,
		isGradesModalOpen,
		openGradesModal,
		closeGradesModal,
	};
};
